import AuthLayoutSubmitButton from "../../components/shared-components/buttons/AuthLayoutSubmitButton";
import styles from "./SignIn.module.css";
import { useNavigate } from "react-router-dom";
import {useForm} from 'react-hook-form'
import EmailInputField from "../../components/shared-components/input-field/EmailInputField";
import PasswordInputField from "../../components/shared-components/input-field/PasswordInputField";
import ToasterWithMessage from '../../components/shared-components/toaster/index'
import { useContext, useState } from "react";
import { CircularProgress } from "@mui/material";
import {signIn} from 'aws-amplify/auth'
import { useLazyQuery } from "@apollo/client";
import { GET_USER_ROLE } from "./api/SignInQuery";
import { globalContext } from "../../Provider/AppProvider";
import { roles,getRoleFromDomain, isRoleAllowed } from "../../helper";

interface SignInSubmitData {
  email: string,
  password: string
}
const SignIn= () => {
  const {error}= ToasterWithMessage();
  const roleFromDomain = getRoleFromDomain();
  const [callSignInData,setCallSignInData] = useState<SignInSubmitData>();
  const [loading, setLoading] = useState(false);
  const [disableBtn,setDisableBtn]= useState(false);
  const {register,handleSubmit,reset,formState: {errors}} = useForm({defaultValues: {email:"",password: ""},mode: "onTouched"});
  const navigate = useNavigate();
  const {globalState,handleGlobalState} = useContext<any>(globalContext);

  // navigating to the forgot password page
  const handleClickForgotPassword = () => {
    navigate("/forgot-password");
  };

  const [getUserRole] = useLazyQuery(GET_USER_ROLE,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data && data?.user.length !== 0){
        const allowedRoles = data?.user?.[0]?.u_allowed_roles?.filter((role: string) => role === roles.AFFILIATER_ADMIN || role === roles.SUPER_USER);
        const role = allowedRoles?.length ? allowedRoles[0] : data?.user?.[0]?.u_role;
        if(callSignInData){
          if(isRoleAllowed(role,roleFromDomain)){
            CognitoSignIn(callSignInData,role);
          }else{
            setLoading(false);
            setDisableBtn(false);
            error("You don't have permission to access this page");
          }
        }else{
          setLoading(false);
          setDisableBtn(false);
          error("User does not exist.");
        }
      }else {
        setLoading(false);
        setDisableBtn(false);
        error("User does not exist.");
      }
    },
    onError: () => {
      setLoading(false);
      setDisableBtn(false);
      error("Something went wrong while fetching user role!");
    }
  });

  const handleSubmitData = async (data: SignInSubmitData)=>{
    setLoading(true)
    if(errors.email || errors.password){
      setDisableBtn(false);
    }else{
      setDisableBtn(true);
    }
    setCallSignInData(data);
    getUserRole({variables: {emailId: data?.email}});
  }

  const CognitoSignIn = async (data: SignInSubmitData,role:string) => {
    try {
      await signIn({username: data.email,password: data.password})
     .then((datas)=>{
       if(datas?.isSignedIn){                
               localStorage.setItem("x-hasura-user-role",role);
               reset({email: "",password: ""})
               const tempState={...globalState}
                tempState.profile.userRole=role
                handleGlobalState({...tempState,tempState})
               if(role===roles.ADMIN || role===roles.AFFILIATER_ADMIN || role===roles.SUPER_USER){
                navigate("/dashboard");
               }else if(role==="logitix_user"){
                navigate("/tickets");
               }else if(role==="marketing_user"){
                navigate("/users")
               }else{
                error("You don't have permission to access this page");
                navigate("/login");
               }
               setLoading(false);
       }
     })
     .catch((err)=>{
       setDisableBtn(false);
       setLoading(false);
       error(err?.message);
     })
   } catch (errors) {
     setDisableBtn(false);
     setLoading(false);
     error('Something went wrong!');
   }
  }

  return (
    <>
    <form onSubmit={handleSubmit(handleSubmitData)} autoComplete="off">
      <div className={loading ? styles.loadSignInForm : styles.signInForm}>
      <div className={styles.textField}>
        <div className={styles.textFieldFullMain}>
          <div className={styles.titlePlaceholder}>
            <div className={styles.email}>Email</div>
          </div>
         <EmailInputField disabled={false} errors={errors} register={register} moduleName={"signin"}/>
        </div>
        <div className={styles.textFieldFullMain1}>
          <div className={styles.titlePlaceholder1}>
            <div className={styles.email}>Password</div>
          </div>
         <PasswordInputField errors={errors} register={register}/>
        </div>
        { (roleFromDomain !== roles.SUPER_USER && roleFromDomain!== roles.USER) && 
        (
          <div className={styles.forgotPassword} onClick={handleClickForgotPassword}>Forgot Password?</div>
        )}
      </div>
        {
          loading
        ?
         <div className={styles.signInCircular}>
         <CircularProgress color={"primary"} size={30}/>
         </div>
        : ''
        }
      <AuthLayoutSubmitButton title={"Sign In"} disableBtn={disableBtn}/>
      </div>
    </form>
    </>
  );
};

export default SignIn;
